module.exports = __webpack_public_path__ + "img/icon_address.55886fa8.svg";